/** Dispatched after streams/projects change so dashboard and streams pages refetch org data. */
export const ORGANISATION_STREAMS_CHANGED = 'organisation-streams-changed';
